<template>
  <v-content>
    <v-container fluid>
      <v-layout row wrap align-center justify-center>
        <v-flex xs12 md6>
          <transition name="fadeFast">
            <v-alert
              v-model="error.show"
              color="error"
              icon="warning"
              dismissible
            >
              {{ error.message }}
            </v-alert>
          </transition>
        </v-flex>
      </v-layout>
      <v-layout row wrap align-center justify-center>
        <v-flex xs12 md6>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Bejelentkezéssdfsdf</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  prepend-icon="alternate_email"
                  name="login"
                  label="Email cím"
                  type="text"
                  v-model="formLogin.email"
                ></v-text-field>
                <v-text-field
                  id="password"
                  prepend-icon="lock"
                  name="password"
                  label="Jelszó"
                  type="password"
                  v-model="formLogin.password"
                ></v-text-field>
              </v-form>

              <!-- <router-link :to="{ name: 'registration'}" >
                                Regisztráció    
                            </router-link> -->
              <br />
              <router-link :to="{ name: 'newPassword' }">
                Elfelejtettem a jelszavam
              </router-link>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" @click="$router.push({ name: 'main' })">
                <v-icon left dark>keyboard_arrow_left</v-icon>
                Vissza
              </v-btn>
              <!-- <v-btn color="info" @click="$router.push({name: 'newPassword'})">
                                <v-icon left dark>replay</v-icon>
                                Új jelszó
                            </v-btn> -->
              <v-btn color="primary" @click="authenticate">
                Bejelentkezésasd
                <v-icon right dark>input</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from 'axios';

export default {
  components: {},
  data: () => ({
    drawer: null,
    formLogin: {
      email: '',
      password: ''
    },
    error: {
      show: false,
      code: '',
      message: ''
    }
  }),
  props: {
    source: String
  },
  methods: {
    authenticate() {
      this.$store.dispatch('login');

      axios
        .post(this.$store.getters.getApiUrl + '/api/login', {
          email: this.$data.formLogin.email,
          password: this.$data.formLogin.password
        })
        .then(response => {
          if (response.data.token.length > 0) {
            this.$store.commit('loginSuccess', {
              token: response.data.token,
              isLoggedIn: true,
              currentUser: response.data.currentUser
            });

            this.$store.commit('setIsAppState', {
              isApp: false
            });

            this.$router.push({ path: '/home' });
          }
        })
        .catch(error => {
          // console.log("error", error.response.data);

          this.$data.error.message = error.response.data.message;
          this.$data.error.code = error.response.data.code;
          this.$data.error.show = true;
          // this.$store.commit("loginFailed", {error});
        });
    },
    isAuthenticated() {}
  },
  computed: {
    authError() {
      return this.$store.getters.authError;
    },
    registeredUser() {
      return this.$store.getters.registeredUser;
    }
  }
};
</script>
